import React, { useCallback } from 'react'
import NumberFormat, { NumberFormatProps } from 'react-number-format'

type Props = Omit<NumberFormatProps, 'onValueChange'> & {
  readOnly ?: boolean,
  onSet ?: (value: string | undefined) => void,
  error ?: string,
  className ?: string,
  allowNegativeValue ? : false
}

const PercentageInput = (props : Props) => {
  const {
    onSet,
    readOnly,
    className,
    error,
    allowNegativeValue,
    ...rest
  } = props

  const onValueChange = useCallback((event) => {
    let value = allowNegativeValue ? event.floatValue : Math.abs(event.floatValue)
    if (!value) {
      value = 0
    }
    onSet(value)
  }, [allowNegativeValue])

  return (
    <NumberFormat
      placeholder="0%"
      className={`${className || 'form-input w-100'}${error ? ' error' : ''}`}
      onValueChange={onValueChange as any}
      suffix="%"
      disabled={readOnly}
      {...rest}
    />
  )
}

export default React.memo<Props>(PercentageInput)
